<ion-nav [root]="rootComponent"></ion-nav>